(() => {
  const dialog = document.getElementById('asos-complement');
  if (!dialog || !dialog.showModal) return;
  const start = Date.parse('2026-10-05T00:00:00-03:00');
  const end = Date.parse('2026-10-08T23:59:59-03:00');
  const active = () => Date.now() >= start && Date.now() <= end;
  const root = window.Shopify?.routes?.root || '/';
  const toys = new Set(dialog.dataset.toys.split(',').filter(Boolean));
  const options = [...dialog.querySelectorAll('[data-complement-option]')];
  const complements = new Set(options.map(o => o.dataset.variant));
  const status = dialog.querySelector('[role="status"]');
  let previous = null, timer, busy = false, shown = false, returnFocus;
  const nativeFetch = window.fetch.bind(window);
  const cart = async () => {
    const response = await nativeFetch(root + 'cart.js', {cache:'no-store'});
    if (!response.ok) throw new Error('Confira seu carrinho e tente novamente.');
    return response.json();
  };
  const eligible = c => c.currency === 'BRL' && c.items.some(i => toys.has(String(i.product_id))) && !c.items.some(i => complements.has(String(i.variant_id)));
  const counts = c => new Map(c.items.filter(i => toys.has(String(i.product_id))).map(i => [i.key, i.quantity]));
  async function stock() {
    await Promise.all(options.map(async o => {
      try {
        const response = await nativeFetch(root + 'products/' + o.dataset.handle + '.js', {cache:'no-store'});
        if (!response.ok) throw new Error();
        const p = await response.json(), v = p.variants.find(v => String(v.id) === o.dataset.variant);
        const available = v && v.available && v.price === 3506;
        const b = o.querySelector('button');
        b.disabled = !available; b.textContent = available ? 'Escolher este' : 'Indisponível';
      } catch { o.querySelector('button').disabled = true; }
    }));
  }
  async function open(preview = false) {
    if (shown || busy || (!preview && !active())) return;
    shown = true;
    await stock();
    if (!options.some(o => !o.querySelector('button').disabled)) return;
    returnFocus = document.activeElement;
    dialog.showModal();
  }
  async function check() {
    if (!active() || busy) return;
    try {
      const current = await cart(), next = counts(current);
      const increased = previous && [...next].some(([key, qty]) => qty > (previous.get(key) || 0));
      previous = next;
      if (dialog.open && !eligible(current)) dialog.close();
      if (increased && eligible(current)) await open();
    } catch { /* Keep normal cart behavior available. */ }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(check, 500); }
  document.addEventListener('cart-update', schedule);
  if (window.jQuery) window.jQuery(document).on('ajaxSuccess.asosComplement', (_e, _xhr, settings) => {
    if (/\/cart\/(add|change|update)(\.js)?(?:\?|$)/.test(settings.url)) schedule();
  });
  if (window.PerformanceObserver) {
    try {
      const observer = new PerformanceObserver(list => {
        if (list.getEntries().some(e => /\/cart\/(add|change|update)(\.js)?(?:\?|$)/.test(new URL(e.name).pathname))) schedule();
      });
      observer.observe({type:'resource', buffered:false});
    } catch { /* Existing cart event remains available. */ }
  }
  dialog.querySelectorAll('[data-complement-close]').forEach(b => b.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', e => { if (e.target === dialog) {
    const r = dialog.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
  }});
  dialog.addEventListener('close', () => { if (returnFocus?.isConnected) returnFocus.focus(); });
  options.forEach(o => o.querySelector('button').addEventListener('click', async () => {
    if (busy) return;
    busy = true; status.textContent = 'Adicionando seu complemento...';
    options.forEach(o => o.querySelector('button').disabled = true);
    try {
      const current = await cart();
      if (!active() || !eligible(current)) throw new Error('Confira o toy e o complemento no carrinho para aproveitar a oferta.');
      const productResponse = await nativeFetch(root + 'products/' + o.dataset.handle + '.js', {cache:'no-store'});
      if (!productResponse.ok) throw new Error('Tente novamente em instantes.');
      const product = await productResponse.json(), variant = product.variants.find(v => String(v.id) === o.dataset.variant);
      if (!variant?.available || variant.price !== 3506) throw new Error('Este complemento está indisponível. Escolha outra opção.');
      const response = await nativeFetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:Number(o.dataset.variant),quantity:1}]})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Tente novamente em instantes.');
      const updated = await cart(); previous = counts(updated);
      dialog.close();
      if (window.halo?.updateSidebarCart) {
        window.halo.updateSidebarCart(updated);
        document.body.classList.add('cart-sidebar-show');
      } else if (window.sharedFunctions?.updateSidebarCart) {
        window.sharedFunctions.updateSidebarCart(updated);
        document.body.classList.add('cart-sidebar-show');
      } else { window.location.assign(root + 'cart'); }
      document.dispatchEvent(new CustomEvent('cart-update', {detail:updated}));
    } catch (error) { status.textContent = error.message; await stock(); }
    finally { busy = false; }
  }));
  cart().then(c => { previous = counts(c); }).catch(() => {});
  const params = new URLSearchParams(location.search);
  if ((params.has('preview_theme_id') || window.Shopify?.designMode) && params.get('asos_complement_preview') === '1') open(true);
})();